module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-black-down.3f33b478.svg";